import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { useUserSubscriptionTierQuery } from "../../../api/features/user-subscription/useUserSubscriptionTier.query";
import { FeatureFlagVariables } from "../../../constants/featureFlag";
import { PaywallABTestVariant } from "../../../constants/paywallABTestVariant.enum";
import {
  BONUSX_SUBSCRIPTION_TIERS,
  GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP,
} from "../../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";

const DEFAULT_FLAG_VALUE = false;

function mapBooleanToVariant(isElevenLabsWidgetAvailable: boolean): PaywallABTestVariant {
  return isElevenLabsWidgetAvailable ? PaywallABTestVariant.ELEVENLABS : PaywallABTestVariant.CLARA;
}

export function usePaywallABTestVariant(): PaywallABTestVariant | null {
  const { currentUserTier } = useUserSubscriptionTierQuery();
  const normalizedTier = GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP[currentUserTier];
  const isFreeUser = normalizedTier === BONUSX_SUBSCRIPTION_TIERS.FREE;

  const isElevenLabsWidgetAvailable = useBooleanFlagValue(
    FeatureFlagVariables.isElevenLabsWidgetAvailable,
    DEFAULT_FLAG_VALUE,
    {
      updateOnContextChanged: true,
    }
  );

  if (!isFreeUser) {
    return null;
  }

  return mapBooleanToVariant(isElevenLabsWidgetAvailable);
}
